<template>
  <div>
    <h3>用户列表</h3>
    <el-table :data="tableData" border>
      <el-table-column prop="id" label="ID"/>
      <el-table-column prop="nickname" label="昵称"/>
      <el-table-column prop="phone" label="手机号"/>
      <el-table-column prop="gender" label="性别"/>
      <el-table-column prop="badge" label="铭牌"/>
      <el-table-column prop="banned" label="状态">
        <template #default="scope">
          <el-tag :type="scope.row.banned?'danger':'success'">{{scope.row.banned?'禁用':'正常'}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {getUserList} from "../api";
export default {
  data(){
    return {tableData:[]}
  },
  mounted(){
    this.loadData()
  },
  methods:{
    async loadData(){
      const res = await getUserList()
      this.tableData = res.data.list
    }
  }
}
</script>
